import React, { useState, useEffect, useContext } from "react"
import nookies from "nookies"
import { auth } from "../../helpers/auth"
import moment from "moment"
import { setPersistence, browserSessionPersistence, browserLocalPersistence} from "firebase/auth"
import { useBrowserSessionGuard } from "./useBrowserSessionGuard"
export const AuthContext = React.createContext({
  user: null
})

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)

  useBrowserSessionGuard()

  useEffect(() => {
    const setupPersistence = async () => {
      await setPersistence(auth, browserLocalPersistence)
    
    return auth.onIdTokenChanged(async user => {
      if (user) {
        const { claims } = await user.getIdTokenResult()
        const token = await user.getIdToken()
        setUser({ ...user, claims })
        nookies.set(undefined, "token", token, {
          path: "/",
        })
      }
      else {
        setUser(null)
      }
    })
  }

  const unsubscribePromise = setupPersistence()

    return () => {
      unsubscribePromise.then((unsubscribe) => unsubscribe && unsubscribe())
    }
  }, [])

  useEffect(() => {
    const handle = setInterval(async () => {
      const user = auth.currentUser
      if (user) await user.getIdToken(true)
    }, 1000 * 60 * 59)
    return () => clearInterval(handle)
  }, [])

  return (
    <AuthContext.Provider value={{ user }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  return useContext(AuthContext)
}
